module.exports = __webpack_public_path__ + "img/home-about-img4.0dac6215.png";